<template>
  <div class="page">
    <div class="top">
      <img class="img4" src="@/assets/home/img4.png" alt="" />
      <div class="cuotas">Préstamos rápidos, cuotas flexibles!</div>
      <div class="Una">
        Una aplicación de préstamos segura y confiable: solicitud en línea,
        desembolso rápido, plazos flexibles a elegir, préstamos sin garantía y
        basados en crédito puro.
      </div>
      <div class="App">
        <img class="img2" src="@/assets/home/img2.png" alt="" />
        <span>Descargar App</span>
      </div>
    </div>
    <div class="page-title">
      <div class="zhutitle">
        <span>¿Cómo solicitar un préstamo?</span>
        <img class="img1" src="@/assets/home/img1.png" alt="" />
      </div>
      <div class="subtitle">
        Necesitas ser mayor de 18 años, tener una identificación válida y contar
        con capacidad de reembolso.
      </div>
    </div>
    <div class="colorBox">
      <div class="box1"></div>
      <div class="box2">
        <span class="box-num">01</span>
        <img class="box-icon" src="@/assets/home/img18.png" alt="" />
        <span class="box-title">Instalación y registro</span>
        <span class="box-desc">
          Instala y descarga la aplicación en la App Store de Apple.
        </span>
      </div>
      <div class="box3">
        <span class="box-num">02</span>
        <img class="box-icon" src="@/assets/home/img14.png" alt="" />
        <span class="box-title">Rellenar información</span>
        <span class="box-desc">
          Después de completar el registro, ingresa tu información personal
          real.
        </span>
      </div>
      <div class="box4">
        <span class="box-num">03</span>
        <img class="box-icon" src="@/assets/home/img20.png" alt="" />
        <span class="box-title">Esperar revisión</span>
        <span class="box-desc">
          Después de enviar la solicitud, espera pacientemente la revisión.
        </span>
      </div>
      <div class="box5">
        <span class="box-num">04</span>
        <img class="box-icon" src="@/assets/home/img19.png" alt="" />
        <span class="box-title">Esperar desembolso</span>
        <span class="box-desc">
          Una vez aprobada la revisión financiera, los fondos se transferirán
          rápidamente a tu cuenta.
        </span>
      </div>
      <div class="box6"></div>
    </div>
    <div class="page-title">
      <div class="zhutitle">
        <span>Introducción del producto</span>
        <img class="img1" src="@/assets/home/img1.png" alt="" />
      </div>
    </div>
    <div class="producto">
      <img class="guangao1" src="@/assets/home/img27.png" alt="" />
      <div class="desc-box">
        <div class="desc-item">
          <img class="img3" src="@/assets/home/img3.png" alt="" />
          <span class="producto-title">Monto del préstamo</span>
          <span class="producto-sub">de $200 a $30,000</span>
        </div>
        <div class="desc-item">
          <img class="img3" src="@/assets/home/img8.png" alt="" />
          <span class="producto-title">Tasa de interés anual</span>
          <span class="producto-sub">
            <span>del 10% al 36% </span>
            <div class="producto-desc">
              (dependiendo de la calificación de crédito del usuario, puede
              haber fluctuaciones según el mercado)
            </div>
          </span>
        </div>
        <div class="desc-item">
          <img class="img3" src="@/assets/home/img5.png" alt="" />
          <span class="producto-title">Plazo del préstamo</span>
          <span class="producto-sub">de 90 a 180 días</span>
        </div>
        <!-- <div class="desc-item">
          <img class="img3" src="@/assets/home/img6.png" alt="" />
          <span class="producto-title">Tarifa de gestión</span>
          <span class="producto-sub">$0</span>
        </div> -->
        <div class="desc-item">
          <img class="img3" src="@/assets/home/img7.png" alt="" />
          <span class="producto-title">IVA</span>
          <span class="producto-sub">16%</span>
        </div>
      </div>
    </div>
    <div class="Ejemplo">
      <img class="img9" src="@/assets/home/img9.png" alt="" />
      <span>Ejemplo</span>
    </div>
    <div class="Supongamos">
      <img class="img13" src="@/assets/home/img13.png" alt="" />
      <span>Supongamos el siguiente caso</span>
    </div>
    <div class="setps">
      <div class="setp-item1">
        <div class="setp-title">Monto del préstamo</div>
        <div class="setp-desc">$6,000 MXN</div>
      </div>
      <div class="setp-item5">
        <div class="setp-title">Tasa de interés anual</div>
        <div class="setp-desc">
          21.9% (usamos un valor intermedio para el ejemplo)
        </div>
      </div>
      <div class="setp-item2">
        <div class="setp-title">Plazo del préstamo</div>
        <div class="setp-desc">90 días (3 meses)</div>
      </div>
      <div class="setp-item3">
        <div class="setp-title" style="color: white">Tarifa de gestión</div>
        <div class="setp-desc" style="color: white">
          $0 (sin tarifas de gestión)
        </div>
      </div>
      <div class="setp-item4">
        <div class="setp-title" style="color: white">IVA</div>
        <div class="setp-desc" style="color: white">
          16% (impuesto al valor agregado)
        </div>
      </div>
    </div>
    <div class="Supongamos">
      <img class="img13" src="@/assets/home/img16.png" alt="" />
      <span>Pasos de cálculo</span>
    </div>
    <div class="nums">
      <div class="num-item">
        <div class="num">01</div>
        <div class="line"></div>
        <div>
          <div class="num-title">Tasa de interés mensual</div>
          <div class="num-desc">·Tasa de Interés Diaria = Tasa anual / 365</div>
          <div class="num-desc">
            ·Tasa de Interés Diaria = 21.9% / 365 = 0.06%
          </div>
        </div>
      </div>
      <div class="num-item">
        <div class="num">02</div>
        <div class="line"></div>
        <div>
          <div class="num-title">Interés total</div>
          <div class="num-desc">
            ·Interés total = Monto del préstamo ×Tasa de Interés Diaria × Plazo
            del préstamo
          </div>
          <div class="num-desc">
            ·Interés total = $6,000 × 0.06% × 90 = $324 MXN
          </div>
        </div>
      </div>
      <div class="num-item">
        <div class="num">03</div>
        <div class="line"></div>
        <div>
          <div class="num-title">Cálculo del impuesto (IVA)</div>
          <div class="num-desc">·Impuesto = Interés total × IVA</div>
          <div class="num-desc">·Impuesto = $324× 16% = $51.84 MXN</div>
        </div>
      </div>
      <div class="num-item">
        <div class="num">04</div>
        <div class="line"></div>
        <div>
          <div class="num-title">Monto total a pagar</div>
          <div class="num-desc">
            ·Monto total a pagar = Monto del préstamo + Interés total + Impuesto
          </div>
          <div class="num-desc">
            ·Monto total a pagar = $6,000 + $324 + $51.84 = $6,375.84 MXN
          </div>
        </div>
      </div>
    </div>
    <div class="Supongamos">
      <img class="img13" src="@/assets/home/img17.png" alt="" />
      <span>Resumen del ejemplo</span>
    </div>
    <div class="ejemplo-text">
      <div class="text-box">
        <div style="margin-bottom: 30px">
          Si tomas un préstamo de $6,000 MXN, con un plazo de 90 días y una tasa
          de interés anual del 21.9%, el monto total que debes pagar sería de
          $6,375.84 MXN, que incluye intereses de $324 MXN y impuestos de $51.84
          MXN.
        </div>
        <div>
          Ten en cuenta que este es solo un cálculo de ejemplo, las tasas reales
          de interés y los impuestos pueden variar según el mercado y la
          calificación de crédito personal.
        </div>
      </div>
      <img class="img10" src="@/assets/home/img10.png" alt="" />
    </div>
    <div class="page-title">
      <div class="zhutitle">
        <span>Calificación de cumplimiento normativo </span>
        <img class="img1" src="@/assets/home/img1.png" style="left: 0" />
      </div>
    </div>
    <div class="Contacto">
      <div class="url">
        <span class="tishi"
          >Contamos con una licencia financiera en cumplimiento de la normativa
          aplicable:</span
        >
        <span
          style="text-decoration: underline; cursor: pointer"
          @click="topage"
          >https://webapps.condusef.gob.mx/SIPRES/jsp/home_publico.jsp?idins=16394</span
        >
        <img class="img37" src="@/assets/home/img37.png" />
      </div>
    </div>
    <div class="b-banner">
      <img class="img29" src="@/assets/home/img29.png" />
    </div>
    <!-- <div class="crads">
      <div class="crad-item">
        <img class="img12" src="@/assets/home/img12.png" alt="" />
        <div class="crad-title">Nombre de la empresa</div>
        <div class="crad-desc">Zoriona, S.A. de C.V., SOFOM, E.N.R.</div>
      </div>
      <div class="crad-item item2">
        <img class="img12" src="@/assets/home/img11.png" alt="" />
        <div class="crad-title">Dirección</div>
        <div class="crad-desc">
          AVENIDA ROBLE 555 PISO 4, VALLE DEL CAMPESTRE, SAN PEDRO GARZA GARCIA,
          NUEVO LEON 66265 MEXICO
        </div>
      </div>
      <div class="crad-item">
        <img class="img12" src="@/assets/home/img26.png" alt="" />
        <div class="crad-title">Email</div>
        <div class="crad-desc">servicio@zorionasofom.com</div>
      </div>
      <img class="img15" src="@/assets/home/img15.png" alt="" />
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {};
  },
  methods: {
    topage() {
      window.open(
        'https://webapps.condusef.gob.mx/SIPRES/jsp/home_publico.jsp?idins=16394'
      );
    },
  },
};
</script>

<style scoped>
.top {
  height: 908px;
  background: linear-gradient(180deg, #9bbce7 0%, #c5dbf7 42%, #eff6ff 100%);
  position: relative;
  margin-top: -70px;
  padding: 216px 360px;
  box-sizing: border-box;
  margin-bottom: 40px;
}
.img4 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 785px;
}
.cuotas {
  width: 568px;
  font-weight: bold;
  font-size: 50px;
  color: #000000;
  margin-bottom: 28px;
}
.Una {
  margin-bottom: 72px;
  width: 698px;
  font-size: 16px;
  color: #5e6b8e;
  line-height: 26px;
}
.App {
  display: flex;
  align-items: center;
  width: 349px;
  height: 78px;
  background: linear-gradient(270deg, #ffb900 0%, #ff8f00 100%);
  border-radius: 39px;
  position: relative;
  justify-content: center;
  font-weight: bold;
  font-size: 30px;
  color: #ffffff;
}
.img2 {
  width: 50px;
  height: 50px;
  margin-right: 12px;
}
.page-title {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.zhutitle {
  font-weight: bold;
  font-size: 46px;
  color: #000000;
  position: relative;
  text-align: center;
  margin-bottom: 24px;
}
.img1 {
  width: 431px;
  height: 44px;
  position: absolute;
  left: 0;
  bottom: -35px;
}
.subtitle {
  font-weight: 400;
  font-size: 24px;
  color: #000000;
}
.colorBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 70px;
}

.box1 {
  width: 338px;
  height: 461px;
  background-image: url('@/assets/home/bg1.png');
  background-size: 100% 100%;
}
.box2 {
  width: 284px;
  height: 360px;
  box-sizing: border-box;
  background-image: url('@/assets/home/bg2.png');
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 27px;
}
.box3 {
  width: 284px;
  height: 310px;
  box-sizing: border-box;
  background-image: url('@/assets/home/bg3.png');
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 27px;
}
.box4 {
  width: 284px;
  height: 310px;
  box-sizing: border-box;
  background-image: url('@/assets/home/bg4.png');
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 27px;
}
.box5 {
  width: 284px;
  height: 360px;
  box-sizing: border-box;
  background-image: url('@/assets/home/bg5.png');
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 27px;
}
.box6 {
  width: 338px;
  height: 461px;
  background-image: url('@/assets/home/bg6.png');
  background-size: 100% 100%;
}
.box-num {
  font-weight: 800;
  font-size: 40px;
  color: #ffffff;
  margin-bottom: 24px;
}
.box-icon {
  width: 62px;
  height: 62px;
  margin-bottom: 18px;
}
.box-title {
  font-weight: bold;
  font-size: 20px;
  color: #ffffff;
  margin-bottom: 20px;
}
.box-desc {
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  line-height: 22px;
}
.producto {
  padding: 0 360px;
  margin-top: 72px;
  display: flex;
  justify-content: space-between;
}
.guangao1 {
  width: 504px;
  height: 378px;
}
.img3 {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
.desc-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.desc-item {
  display: flex;
  align-items: center;
}
.producto-title {
  font-size: 20px;
  color: #000000;
  margin-right: 40px;
  width: 198px;
}
.producto-sub {
  font-weight: bold;
  font-size: 26px;
  color: #000000;
}
.producto-desc {
  width: 356px;
  font-size: 14px;
  color: #000000;
  line-height: 16px;
  margin-top: 10px;
}
.Ejemplo {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 42px;
  color: #000000;
  margin-top: 76px;
}
.img9 {
  width: 52px;
  height: 50px;
  margin-right: 16px;
}
.img13 {
  width: 40px;
  height: 40px;
  margin-right: 14px;
}
.Supongamos {
  padding: 0 360px;
  margin-top: 53px;
  margin-bottom: 34px;
  font-weight: 600;
  font-size: 26px;
  color: #000000;
}
.setps {
  padding: 0 360px;
  display: flex;
  justify-content: space-between;
}
.setp-item1 {
  width: 257px;
  height: 131px;
  background-image: url('@/assets/home/img21.png');
  background-size: 100% 100%;
  padding: 0 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.setp-item2 {
  width: 257px;
  height: 131px;
  background-image: url('@/assets/home/img22.png');
  background-size: 100% 100%;
  padding: 0 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.setp-item3 {
  width: 257px;
  height: 131px;
  background-image: url('@/assets/home/img23.png');
  background-size: 100% 100%;
  padding: 0 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.setp-item4 {
  width: 257px;
  height: 131px;
  background-image: url('@/assets/home/img24.png');
  background-size: 100% 100%;
  padding: 0 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.setp-item5 {
  width: 257px;
  height: 131px;
  background-image: url('@/assets/home/img25.png');
  background-size: 100% 100%;
  padding: 0 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.setp-title {
  font-weight: 600;
  font-size: 15px;
  color: #000000;
  margin-bottom: 10px;
}
.setp-desc {
  font-size: 14px;
  color: #000000;
  text-align: center;
}
.nums {
  padding: 0 360px;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 56px;
}
.line {
  width: 49px;
  border-bottom: 2px dashed #1b67c8;
  margin: 0 10px;
  margin-top: 18px;
}
.num-item {
  display: flex;
  align-items: flex-start;
  width: 50%;
  margin-bottom: 36px;
}
.num {
  font-weight: 600;
  font-size: 24px;
  color: #1b67c8;
}
.num-title {
  margin-bottom: 10px;
  font-weight: 600;
  font-size: 24px;
  color: #000000;
}
.num-desc {
  width: 381px;
  font-weight: 600;
  font-size: 18px;
  color: #000000;
}
.img10 {
  width: 336px;
  height: 193px;
}
.ejemplo-text {
  padding: 0 360px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 110px;
}
.text-box {
  width: 726px;
  font-size: 20px;
  color: #000000;
  line-height: 28px;
}
.crads {
  padding: 0 360px;
  display: flex;
  justify-content: space-between;
  margin-top: 78px;
  margin-bottom: 152px;
  position: relative;
}
.crad-item {
  width: 372px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid #ffffff;
  backdrop-filter: blur(4px);
  padding: 38px 42px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.item2 {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 72px;
}
.img12 {
  width: 68px;
  height: 68px;
  margin-bottom: 28px;
}
.crad-title {
  margin-bottom: 15px;
  width: 297px;
  font-weight: 600;
  font-size: 30px;
  color: #000000;
  text-align: center;
}
.crad-desc {
  text-align: center;
  width: 288px;
  font-size: 20px;
  color: #000000;
}
.img15 {
  width: 288px;
  height: 288px;
  position: absolute;
  left: 50%;
  top: -114px;
  z-index: -1;
}
.Contacto {
  display: flex;
  padding: 0 360px;
  justify-content: space-between;
  margin: 130px 0;
}
.url {
  width: 1200px;
  height: 103px;
  /* line-height: 103px; */
  padding: 0 60px;
  background: linear-gradient(270deg, rgba(209, 225, 243, 0) 0%, #a9ccff 100%);
  border-radius: 83px;
  filter: blur(0px);
  font-weight: bold;
  font-size: 20px;
  color: #1b67c8;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.tishi {
  font-size: 16px;
  margin-bottom: 10px;
  color: #000000;
}
.img37 {
  width: 215px;
  height: 215px;
  position: absolute;
  right: 0;
  top: 0;
}

.b-banner {
  display: flex;
  justify-content: center;
  margin: 130px;
}
.img29 {
  width: 900px;
  height: 671px;
}
</style>
